const Text = require('components/Text/Text');
module.exports = Text;
